import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "team-row" }
const _hoisted_2 = { class: "team-name" }

import { DxButton } from 'devextreme-vue';
import { ServiceTeamItem } from '@/services/entities/ServiceTeams/ServiceTeamItem';


export default /*@__PURE__*/_defineComponent({
  __name: 'ServiceTeamsReport',
  props: {
    data: {Type: [] as ServiceTeamItem[], default: [] as ServiceTeamItem[]},
},
  setup(__props) {

const props = __props;


return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.data, (value) => {
    return (_openBlock(), _createElementBlock("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(value.teamName), 1),
        _createElementVNode("div", null, [
          _createVNode(_unref(DxButton), {
            hint: "Expand team details - not implmentd",
            icon: "spindown",
            "styling-mode": "contained",
            type: "normal",
            disabled: "true"
          }),
          _createVNode(_unref(DxButton), {
            hint: "Download report - not implemented",
            icon: "download",
            "styling-mode": "contained",
            type: "normal",
            disabled: "true"
          })
        ])
      ]),
      _cache[0] || (_cache[0] = _createElementVNode("hr", null, null, -1))
    ]))
  }), 256))
}
}

})